module.exports = __webpack_public_path__ + "static/powered-by-ssd-6d773ac708bac9a75e582c0cbd247371.png";